import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { documentTitleFor, pageTitleFor } from './pageTitle';

/**
 * Per-route chrome: `document.title`, and for screen-reader / keyboard users a focus move to the page
 * content plus a polite "Navigated to X" announcement whenever the pathname changes (not on first load).
 */
export function RouteChrome() {
  const { pathname } = useLocation();
  const first = useRef(true);
  const [announcement, setAnnouncement] = useState('');

  useEffect(() => {
    document.title = documentTitleFor(pathname);
    if (first.current) {
      first.current = false;
      return;
    }
    setAnnouncement(`Navigated to ${pageTitleFor(pathname)}`);
    const main = document.getElementById('main');
    // Do not steal focus from something the screen focused itself (e.g. the POS search box).
    const t = window.setTimeout(() => {
      const active = document.activeElement;
      if (main && (!active || active === document.body || !main.contains(active))) {
        main.focus({ preventScroll: true });
      }
    }, 0);
    return () => window.clearTimeout(t);
  }, [pathname]);

  return (
    <div aria-live="polite" className="sr-only">
      {announcement}
    </div>
  );
}
